import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import React from "react";
import MaterialTextField from "../inputs/MaterialTextField";
import MaterialSelect from "../inputs/MaterialSelect";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import CircularProgress from "@material-ui/core/CircularProgress";
import MaterialDateField from "../inputs/MaterialDateField";


function PersonalFormFR({form, onSubmit, allCountries, submitting}) {
    const {t} = useTranslation();
    return form ? <Grid container spacing={3} justifyContent={"center"} alignItems={"center"}>
        <Grid item xs={12} lg={7}>
            <MaterialSelect
                fullWidth
                margin="normal"
                field={form.$("prefix")}
                labelAccessor={(x=>x)}
                valueAccessor={(x=>x)}
                InputLabelProps={{
                    shrink: true,
                }}/>
        </Grid>
        <Grid item xs={12} lg={7}>
            <MaterialDateField
                fullWidth
                margin="normal"
                field={form.$("dateOfBirth")}
                InputLabelProps={{
                    shrink: true,
                }}/>
        </Grid>

        <Grid item xs={12} lg={7}>
            <MaterialSelect
                fullWidth
                label="Language"
                margin="normal"
                labelAccessor={(x=>x.countryName)}
                valueAccessor={(x=>x.countryShortCode)}
                field={ form.$("birthCountry") }
                options = {allCountries}/>
        </Grid>
        <Grid item xs={12} lg={7}>
            <MaterialTextField
                fullWidth
                margin="normal"
                field={form.$("birthCity")}
                InputLabelProps={{
                    shrink: true,
                }}/>
        </Grid>

        <Grid item xs={12} lg={7}>
            <MaterialSelect
                fullWidth
                margin="normal"
                labelAccessor={(x=>x)}
                valueAccessor={(x=>x)}
                field={form.$("birthDept")}
                InputLabelProps={{
                    shrink: true,
                }}/>
        </Grid>

        <Grid item xs={12} lg={7}>
            <MaterialSelect
                fullWidth
                label="Language"
                margin="normal"
                labelAccessor={(x=>x.countryName)}
                valueAccessor={(x=>x.countryShortCode)}
                field={ form.$("nationality") }
                options = {allCountries}/>
        </Grid>
        <Grid item xs={12} lg={7}>
            <MaterialTextField
                fullWidth
                margin="normal"
                field={form.$("ssn")}
                InputLabelProps={{
                    shrink: true,
                }}/>
        </Grid>

        <Grid item xs={12} lg={7}>
            <MaterialSelect
                fullWidth
                margin="normal"
                labelAccessor={(x=>x)}
                valueAccessor={(x=>x)}
                field={form.$("distributorContract")}
                InputLabelProps={{
                    shrink: true,
                }}/>
        </Grid>
        {form.$("siret").extra !=="hidden" &&  <Grid item xs={12} lg={7}>
            <MaterialTextField
                fullWidth
                margin="normal"
                field={form.$("siret")}
                InputLabelProps={{
                    shrink: true,
                }}/>
        </Grid>}
        <Grid item xs={12} lg={7}>
            <MaterialSelect
                fullWidth
                margin="normal"
                labelAccessor={(x=>x)}
                valueAccessor={(x=>x)}
                field={form.$("subjectSocial")}
                InputLabelProps={{
                    shrink: true,
                }}/>
        </Grid>
        <Grid item xs={12} lg={7}>
        <MaterialSelect
            fullWidth
            margin="normal"
            labelAccessor={(x=>x)}
            valueAccessor={(x=>x)}
            field={form.$("subjectVat")}
            InputLabelProps={{
                shrink: true,
            }}/>
    </Grid>

        {( onSubmit && ( submitting === undefined || !submitting  )) && <Grid item xs={12} lg={7}>
            <Button  onClick={onSubmit} fullWidth variant={"contained"}
                     color="primary">{t("enrollment:continue")}</Button>

        </Grid>}
        { onSubmit && ( submitting ) && <Grid item xs={12} lg={7}>
            <CircularProgress/>
        </Grid>}
    </Grid>:null
}

export default observer(PersonalFormFR)